import { PageHeading } from '../../components';
import ManagementTab from './ManagementTab';

function UpdateManagement() {
  return (
    <div className="z-10 bookings-table">
      <title>Update Management</title>
      <PageHeading title="Update Management" description=""></PageHeading>
      <ManagementTab />
    </div>
  );
}

export default UpdateManagement;
